export const merchantErrorHeader = "Error loading your profile information";
export const merchantErrorMessage =
  "Your profile could not be loaded. Please try again or contact iKhokha on 087 222 7000 or email us at support@ikhokha.com";
export const authErrorHeader = "Unauthorised Entry";
export const authErrorMessage = "You do not have authorisation to access this page";
export const invoiceErrorHeader = "Unable to retrieve your invoice history";
export const invoiceErrorMessage = `Please try again or contact iKhokha  on 087 222 7000 or email us at support@ikhokha.com`;
